<template>
    <span>
        <DaiCapaGeojson
        id="propiedadesSuelo_ph"
        :url="publicPath+'data/capasv2/10_caracteristicas_suelos.geojson'"
        titulo=".."
        :estilo-capa="{ stroke: { width: .5,color:'gray' } }"
        :z-index="6"
        :renderizarComoImagen="true"
        :visible="propiedadSueloSeleccionado === 'ph' && esteTemaActivo"
        :reglas-estilo-capa="{
            clasificacion:'categorias',
            columna:'ph_int',
            colores:['#39C704','#FBFE1D','#F7001A','#7C02A6'],
            acomodoCategorias:['<7.5','7.5 a 8.5','8.6 a 10','>10']
        }"
        :contenidoTooltip="f=>`pH (0 a 20 cm de profundidad) <b>${f.ph_int}</b>`"
        :use-loader="true"
        />
        <DaiCapaGeojson
        id="propiedadesSuelo_ce"
        :url="publicPath+'data/capasv2/10_caracteristicas_suelos.geojson'"
        titulo=".."
        :estilo-capa="{ stroke: { width: .5,color:'gray' } }"
        :z-index="6"
        :renderizarComoImagen="true"
        :visible="propiedadSueloSeleccionado === 'salinidad' && esteTemaActivo"
        :reglas-estilo-capa="{
            clasificacion:'categorias',
            columna:'ce_int',
            colores:['#39C704','#FBFE1D','#F7001A','#7C02A6'],
            acomodoCategorias:['<4','4 a 15','15.1 a 30','>30']
        }"
        :contenidoTooltip="f=>`Salinidad superficial <b>${f.ce_int}</b>`"
        :use-loader="true"
        />
        <DaiCapaGeojson
        id="propiedadesSuelo_riesgo"
        :url="publicPath+'data/capasv2/10_caracteristicas_suelos.geojson'"
        titulo=".."
        :estilo-capa="{ stroke: { width: .5,color:'gray' } }"
        :z-index="6"
        :renderizarComoImagen="true"
        :visible="propiedadSueloSeleccionado === 'riesgo' && esteTemaActivo"
        :reglas-estilo-capa="{
            clasificacion:'categorias',
            columna:'riesg_ero',
            colores:['#39C704','#FBFE1D','#F7001A','#7C02A6'],
            acomodoCategorias:['Bajo','Medio','Alto','Muy alto']
        }"
        :contenidoTooltip="f=>`Riesgo de erosión eólica <b>${f.riesg_ero}</b>`"
        :use-loader="true"
        />
    </span>
</template>


<script>
import { mapState } from "vuex";

export default {
    data(){
        return {
            
            publicPath: process.env.BASE_URL,
        }
    },
    computed:{
        ...mapState("mapa", ["temasExpandidos","propiedadSueloSeleccionado"]),
        esteTemaActivo() {
            return this.temasExpandidos.propiedadesSuelo;
        },
        
    },
    watch: {
    },
}
</script>